import { LvWheelConfigs } from '../types';

export const lvWheelConfig: LvWheelConfigs = {
  assetsUrl: 'https://lvbet-static.com/images/other/lv-wheel-v2',
  assetVariant: 'letsbetmd'
};
